import { render, staticRenderFns } from "./epmallorderitemmeal.vue?vue&type=template&id=78c6c96c"
import script from "./epmallorderitemmeal.vue?vue&type=script&lang=js"
export * from "./epmallorderitemmeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports